import { ClickAwayListener, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PatientBriefFloatingIcon from 'components/common/icons/PatientBriefFloatingIcon'
import PatientBriefUnreadFloatingIcon from 'components/common/icons/PatientBriefUnreadFloatingIcon'
import GrinFloatingPopup from 'components/common/menu/GrinFloatingPopup'
import useRolePermissions from 'hooks/useRolePermissions'
import React, { useCallback, useMemo, useState } from 'react'
import PatientBriefQuickActionsContent from './PatientBriefQuickActionsContent'
import { trackEvent } from 'utils/analyticsUtils'
import { useSelector } from 'react-redux'
import images from 'resources'
import useSpecificMemberAttention from '../../../../hooks/useSpecificMemberAttention'

const useStyles = makeStyles(theme => ({
  container: {
    zIndex: 900,
    position: 'absolute',
    top: 20,
    right: 20,
    cursor: 'pointer'
  },
  floatingPopup: {
    width: 480,
    padding: 0
  },
  tooltip: {
    background: 'white'
  }
}))

const PatientBriefQuickActionsButton = ({ needsAttentionTagDetails, patientId, practiceName }) => {
  const classes = useStyles()
  const { isHiUser } = useRolePermissions()

  const { reason, note, selectedPracticeMembersIds = [] } = needsAttentionTagDetails || {}
  const { noteWithMentions, selectedPracticeMembersTooltip, isAwaitingCurrentMembersAttention } =
    useSpecificMemberAttention({
      note,
      selectedPracticeMembersIds
    })

  const { data: patientBriefData } = useSelector(state => state.patientsReducer.patientBrief)

  const [tooltipOpen, setTooltipOpen] = useState(!isHiUser && !!needsAttentionTagDetails)

  const hasPatientBrief = useMemo(() => patientBriefData?.length > 0, [patientBriefData])

  const handlePatientBriefQuickActionsButtonClick = useCallback(
    () =>
      trackEvent('Patient Brief Quick Actions - Button Clicked', {
        action: tooltipOpen ? 'close' : 'open',
        isHiUser,
        practiceName,
        patientId
      }),
    [isHiUser, tooltipOpen, practiceName, patientId]
  )

  const handlePatientBriefQuickActionsPopupClosed = useCallback(
    () => trackEvent('Patient Brief Quick Actions - closed'),
    []
  )

  return (
    <Grid className={classes.container} onClick={() => setTooltipOpen(!tooltipOpen)}>
      <Grid item>
        <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
          <div>
            <GrinFloatingPopup
              containerClassName={classes.floatingPopup}
              placement="left-start"
              automaticallyOpen={!isHiUser && !!needsAttentionTagDetails}
              triggerComponent={
                <div onClick={handlePatientBriefQuickActionsButtonClick}>
                  {needsAttentionTagDetails ? (
                    <PatientBriefUnreadFloatingIcon
                      style={{ boxShadow: '0px 2px 24px -7px #0000004D', borderRadius: 50 }}
                    />
                  ) : hasPatientBrief ? (
                    <PatientBriefFloatingIcon style={{ boxShadow: '0px 2px 24px -7px #0000004D', borderRadius: 50 }} />
                  ) : (
                    <img src={images.noPatientBriefFloatingIcon} alt="" />
                  )}
                </div>
              }
              open={tooltipOpen}
              onClose={handlePatientBriefQuickActionsPopupClosed}
              withCloseIcon={false}
            >
              <PatientBriefQuickActionsContent
                reason={reason}
                note={noteWithMentions}
                patientId={patientId}
                needsAttentionTagApplied={!!needsAttentionTagDetails}
                actionable={isHiUser || isAwaitingCurrentMembersAttention}
                disabledOverlayTooltip={selectedPracticeMembersTooltip}
              />
            </GrinFloatingPopup>
          </div>
        </ClickAwayListener>
      </Grid>
    </Grid>
  )
}

export default PatientBriefQuickActionsButton
